import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route change EXCEPT when navigation was triggered by a language switch
// If a hash is present, scroll to the matching element instead.
export const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.preserveScroll) return;

    if (location.hash) {
      const id = location.hash.replace("#", "");
      // Wait a tick so the target section is mounted after route change
      const scrollToTarget = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "auto", block: "start" });
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        }
      };
      // Two-step to handle post-mount layout
      requestAnimationFrame(() => requestAnimationFrame(scrollToTarget));
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.hash]);

  return null;
};
